import { $Item } from "../types";
import { $LinkItem } from "./types";

export default function userShare(item: $Item): Promise<ShareData> {
  return new Promise((resolve) => {
    const _item = item as $LinkItem;
    resolve({ text: _item.url });
  });
}
